module.exports = __webpack_public_path__ + "394bd9cdc7f13dbd7ac57aec43a97f46.pdf";